<template>
  <modal v-model="isVisible" v-if="sku !== null">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Histórico de alterações manuais de preços.</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        <ul class="c-stream" v-if="priceHistory.length">
          <li class="c-stream__item " v-for="history in priceHistory" :key="history">
            <span class="c-stream__badge hint error" data-label="Alteração de preço"></span>
            <time class="u-text-muted u-fs-12">{{ history.createdAt | moment('from') }} ({{ history.user.email }})</time>
            <div class="l-row history">
              <div class="l-col-12@md">
                <div class="l-row vertical-flex">
                  <div class="l-col-5@md">
                    <price :price= "history.oldPrice"></price>
                  </div>

                  <div class="l-col-2@md relative">
                    <i class="i-arrow icon-arrow-right center"></i>
                  </div>

                  <div class="l-col-5@md">
                    <price :price="history.newPrice"></price>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div class="u-textCenter teste" v-if="!priceHistory.length">
          Nenhum histórico de alteração de preço encontrado.
        </div>
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn btn--info" @click="close">Fechar</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import Price from '@/components/marketplace/shared/Price'

  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      priceHistory: []
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      sku: {
        type: String,
        required: false
      },
      module: {
        type: Object,
        required: true
      },
      identifier: {
        type: String,
        default: 'default',
        required: false
      },
      code: {
        type: String,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    updated () {
      this.modal = document.querySelector('div.c-modal')

      if (this.modal !== null) {
        this.modal.onclick = (event) => {
          if (event.target === this.modal) {
            this.close()
          }
        }
        document.body.onkeyup = (event) => {
          if (event.code === 'Escape') {
            this.close()
          }
        }
      }
    },
    methods: {
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      },
      async retrieveHistory () {
        const filters = {
          identifier: this.identifier
        }

        if (this.code !== undefined && this.code !== null) {
          filters.code = this.code
        }

        try {
          this.priceHistory = await api.retrievePriceHistory(this.sku, this.module.type, this.module.identifier, filters)
        } catch (e) {
          this.priceHistory = []
        }
      }
    },
    watch: {
      isVisible (value) {
        if (value) {
          this.retrieveHistory()
        }
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    components: {
      Panel,
      Price
    }
  }
</script>

<style lang="sass" scoped>
  strong
    display: block

  .history
    margin-top: 16px
    background: #f5f5f5
    padding: 10px
    margin-bottom: 16px
    padding-bottom: 16px

  .margin
    margin-bottom: 15px

  .center
    position: absolute
    margin: auto
    width: 25px
    height: 25px
    left: 0
    right: 0
    top: 0
    bottom: 0

  .relative
    position: relative
</style>



// WEBPACK FOOTER //
// ModalPriceHistory.vue?7298f4aa